import React, {useCallback, useEffect, useMemo, useReducer, useRef} from 'react'
import FullCalendar from '@fullcalendar/react'
import koLocale from '@fullcalendar/core/locales/ko'
import dayGridPlugin from '@fullcalendar/daygrid'
// import list from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import {useSubheader} from '../../../../_metronic/layout'
import '../fc.css'
import {CalendarModal} from './CalendarModal'
import {getStoreInfo} from '../_redux/calendarCrud'
import moment from 'moment'
import {useLocation} from 'react-router-dom'
import {failedOrderSwal, failedOrderSwalForToss} from '../../../../util/Swals'
import k1utils from '../../../../util/k1utils'

export const padLeft = (nr, n, str) => {
  return Array(n - String(nr).length + 1).join(str || '0') + nr
}

const initialState = {
  show: false,
  data: [],
  store: {},
  storeConfs: [],
  orderNoti: {},
  eventList: [],
  selectedDate: null,
}

export const SET_STORE_INFO = 'SET_STORE_INFO'
export const ON_HIDE = 'ON_HIDE'
export const ON_SHOW = 'ON_SHOW'
export const SET_LIST_DATA = 'SET_LIST_DATA'

const reducer = (state, action) => {
  switch (action.type) {
    case SET_STORE_INFO:
      return {
        ...state,
        data: action.data,
        store: action.store,
        storeConfs: action.storeConfs,
        orderNoti: action.orderNoti,
      }
    case ON_HIDE:
      return {
        ...state,
        show: action.show,
      }
    case ON_SHOW:
      return {
        ...state,
        show: action.show,
      }
    case SET_LIST_DATA:
      return {
        ...state,
        eventList: action.eventList,
        selectedDate: action.selectedDate,
        show: action.show,
      }
    default:
      throw new Error()
  }
}

export function Calendar() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {data, show, store, storeConfs, orderNoti, eventList, selectedDate} = state

  const calendarRef = useRef()
  const location = useLocation()
  const store_identifier = useMemo(() => location.pathname.split('/')[2], [location])

  const suhbeader = useSubheader()
  suhbeader.setTitle(store.name)

  const fetchData = useCallback(() => {
    getStoreInfo(store_identifier)
      .then((res) => {
        const result = res.data.data
        dispatch({
          type: SET_STORE_INFO,
          data: result.schedule,
          store: result.store,
          storeConfs: result.storeConfs,
          orderNoti: result.orderNoti
        })

        const backgroundImageUrl = k1utils.toBigFileUrl(result.store.t_fileidx)
        document.getElementById('root').style.backgroundImage = `url(${backgroundImageUrl})`
      })
      .catch((err) => console.error(err))
  }, [dispatch, store_identifier])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const onHide = useCallback(() => {
    dispatch({type: ON_HIDE, show: false})
  }, [dispatch])

  const onShow = useCallback(
    (date, b, c, storeConfs) => {
      const dateOnly = moment(date.date).format('YYYY-MM-DD')
      const calendarApi = calendarRef.current.getApi()
      let evtTitle = undefined

      const workType = storeConfs.find((e) => e.key === "WORK_TYPE") || { key: "WORK_TYPE", value: "ORDER"};

      calendarApi.select({
        start: date.dateStr,
        allDay: true,
      })

      const eventListData = calendarApi.getEvents().filter((entry) => {
        if (entry['start'].getTime() === new Date(date.date).getTime()) {
          evtTitle = entry['title']
        }
        let startDateOnly =
          entry['start'].getFullYear() +
          '-' +
          padLeft(entry['start'].getMonth() + 1, 2, '0') +
          '-' +
          padLeft(entry['start'].getDate(), 2, '0')
        return startDateOnly === dateOnly
      })

      if (evtTitle) {
        if (evtTitle === '휴무일' || evtTitle === '마감' || evtTitle === '출강') {
          failedOrderSwal(evtTitle, workType.value);
          return false
        }
      }

      let open = true

      // 당일 예약은 시간을 :23시 59분 59초로 설정해서, 미래 시간으로 만듭니다.
      const SAMEDAY_RESERVATION = storeConfs.find((e) => e.key === 'SAMEDAY_RESERVATION')
      if (undefined !== SAMEDAY_RESERVATION && SAMEDAY_RESERVATION.value === 'true') {
        date.date.setHours('23', '59', '59', '999')
      }

      if (date.date < new Date()) {
        open = false
        failedOrderSwal('지난 날짜', workType.value)
      }
      // 토스페이먼츠이용을 위해 6주까지만 예약가능하게 수정했습니다.
      if (date.date > moment().add(42,'days')) {
        open = false
        failedOrderSwalForToss('6주 이상', workType.value)
      }

      if (eventListData) {
        dispatch({
          type: SET_LIST_DATA,
          eventList: eventListData,
          selectedDate: dateOnly,
          show: open,
        })
        return false
      } else {
        dispatch({type: ON_HIDE, show: false})
      }

      // dispatch({type: ON_SHOW, show: true})
    },
    [dispatch]
  )

  const FIRST_NOTICE = storeConfs.find((e) => e.key === 'FIRST_NOTICE')
  if (undefined !== FIRST_NOTICE && FIRST_NOTICE.value === 'true') {
        
  }

  return (
    <div className='card card-custom h-100'>
      {/*
            <div className="card-header d-block p-3">
                <h4 className="d-inline-block">휴무일 : <span className="event-red mr-1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></h4>
                {" / "}
                <h4 className="d-inline-block">마감 : <span className="event-yellow mr-1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></h4>
                {" / "}
                <h4 className="d-inline-block">출강 : <span className="event-orange">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></h4>
            </div>
            */}

      <div className='card-body d-flex flex-column p-3'>

        { (undefined !== FIRST_NOTICE && FIRST_NOTICE.value === 'true') &&
            <div className='flex-glow-1 pb-5'>
             <p dangerouslySetInnerHTML={{__html: orderNoti.firstnoti}} className="text-dark-50 font-weight-normal font-size-lg mt-6 justify-content-center "/>
            </div>
        }
        {/* begin::FullCalendar */}
        <FullCalendar
          ref={calendarRef}
          plugins={[interactionPlugin, dayGridPlugin, bootstrapPlugin]}
          locale={koLocale}
          themeSystem={'bootstrap'}
          initialView='dayGridMonth'
          buttonText={{
            today: 'today',
            month: 'month',
            week: 'week',
            day: 'day',
            list: 'list',
          }}
          eventTimeFormat={{
            hour: 'numeric',
            minute: '2-digit',
            meridiem: 'short',
          }}
          dateClick={(a, b, c) => onShow(a, b, c, storeConfs)}
          // eventClick={(arg) => failedOrderSwal(arg.event.title)}

          visibleRange={{
            start: new Date(),
          }}
          headerToolbar={{
            right: 'today',
            center: 'title',
            left: 'prev,next',
          }}
          footerToolbar={{
            start: '',
            center: '',
            end: '',
          }}
          // editable={true}

          dayMaxEventRows={3}
          dayCellClassNames={function(info) {
            let day = new Date(
              new Date(info.date.getFullYear(), info.date.getMonth(), info.date.getDate(), 0, 0, 0)
            )
              .toLocaleDateString('ko-KR', {weekday: 'long'})
              .substr(0, 1)
            const today = moment(new Date()).format('YYYY-MM-DD')
            const infoDate = moment(info.date).format('YYYY-MM-DD')
            if (day === '토') {
              let str = 'saturday'
              if (today > infoDate) str += ' before-today'
              return str
            } else if (day === '일') {
              let str = 'sunday'
              if (today > infoDate) str += ' before-today'
              return str
            } else if (today > infoDate) {
              return 'before-today'
            } else {
              return undefined
            }
          }}
          dayCellContent={function(info) {
            return info.dayNumberText.split('일')[0]
          }}
          selectable={true}
          // businessHours={true}

          events={data}
        />
        {/* end::FullCalendar */}
      </div>

      <CalendarModal
        show={show}
        onHide={onHide}
        store={store}
        storeConfs={storeConfs}
        data={eventList}
        selectedDate={selectedDate}
      />
    </div>
  )
}
